// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"421":"741f7051","499":"2c402509","573":"977a036b","670":"741f7051","829":"f60854ca"}[chunkId] + ".chunk.css";
};